import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { materialModules } from 'src/shared/material.module';
import { HeaderComponent } from '../header/header.component';
import { ApplicantSearchComponent } from '../shared/applicant-search/applicant-search.component';
import { ViewWorkflowDialogComponent } from './view-workflow-dialog/view-workflow-dialog.component';
import { WorkflowsComponent } from './workflows.component';

@NgModule({
  declarations: [
    WorkflowsComponent,
    ViewWorkflowDialogComponent,
  ],
  imports: [
    CommonModule,
    materialModules,
    HeaderComponent,
    ReactiveFormsModule,
    FormsModule,
    ApplicantSearchComponent,
  ],
  exports: [
    WorkflowsComponent,
    ViewWorkflowDialogComponent,
  ],
})
export class WorkflowsModule { }
